var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4009 21.7578C16.3714 21.7578 20.4009 17.7284 20.4009 12.7578C20.4009 7.78725 16.3714 3.75781 11.4009 3.75781C6.43032 3.75781 2.40088 7.78725 2.40088 12.7578C2.40088 17.7284 6.43032 21.7578 11.4009 21.7578Z",
    fill: "#1B3764",
    stroke: "#1B3764",
    strokeWidth: 2.83465,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80843 13.4396V12.2716H13.5444V13.4396H8.80843Z",
    fill: "#98C4C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineMinus);
export default __webpack_public_path__ + "static/media/timeline-minus.84afcdf22e89ad9eeef9bb69d57c69bf.svg";
export { ForwardRef as ReactComponent };